import { useState } from "react";
import Whatsappmessage from "./Whatsappmessage";
import EmailDashboard from "./EmailDashboard";
import UploadFileModal from "./UploadFileModal";


export default function WhatsappPanel() {

  const [activeTab, setActiveTab] = useState("logs");
  const [openUploadModal, setOpenUploadModal] = useState(false);

  const tabs = [
    { id: "logs", label: "WA Message Logs", component: <Whatsappmessage /> },
    { id: "campaigns", label: "Email Templates", component: <EmailDashboard/> },
    // { id: "templates", label: "Templates", component: <></>}
    { id: "templates", label: "Templates Images", component: 
      <UploadFileModal
      />}
  ];

  return (
    <div className="p-2">

      {/* TAB HEADER */}
      <div className="flex border-b bg-white rounded-t-xl overflow-x-auto">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-5 py-3 text-sm font-semibold transition whitespace-nowrap
              ${
                activeTab === tab.id
                  ? "border-b-2 border-blue-600 text-blue-600 bg-blue-50"
                  : "text-gray-600 hover:bg-gray-100"
              }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* TAB CONTENT */}
      <div className="mt-4">
        {tabs.find((tab) => tab.id === activeTab)?.component}
      </div>

    </div>
  );
}